import React, {createContext, useCallback, useEffect, useState, useRef, useContext, useMemo} from 'react';
import db from '../firebase';
import { collection, getDocs, onSnapshot, orderBy, query, where } from 'firebase/firestore';
import { TailSpin } from 'react-loader-spinner'
import { Center, Text } from '@chakra-ui/react';

const AppContext = createContext({})

export const AppProvider = ({children}) => {
    
    const [players, setPlayers] = useState(null)
    const [catogories, setCatogories] = useState(null)
    const [teams, setTeams] = useState(null)
    const [soldPlayers, setSoldPlayers] = useState([])
    const [reservedPlayers, setReservedPlayers] = useState(null)
    const [latestSell, setLatestSell] = useState(null)
    const [oldSoldPlayers, setOldSoldPlayers] = useState([])
    const [catData, setCatData] = useState(null)
    const [rawCatData, setRawCatData] = useState(null)
    const [initailLoading, setInitialLoading] = useState(true)

    const getCatData = useCallback(async () => {
        const data = await getDocs(query(collection(db, 'catData')))
        const newCatData = {}
        const cats = []
        const raw = []
        data.forEach(d => {
            cats.push(d.data().label)
            raw.push({...d.data(),basePrice: parseInt(d.data().basePrice), cit: d.id})
            newCatData[d.data().label] = {...d.data(), basePrice: parseInt(d.data().basePrice)}
        })
        setRawCatData(raw)
        setCatogories([...cats.sort()])
        setCatData(newCatData)
    }, [])

    const getReserved = useCallback(async () => {
        const data = await getDocs(query(collection(db, 'reservedplayers')))

        let reserved = []
        data.forEach(d => {
            reserved.push({
                ...d.data(),
                rid: d.id,
                cost: parseInt(d.data().cost),
            })
        })
        console.log("reserved", reserved)
        setReservedPlayers([...reserved])
    }, [])

    const getPlayers = useCallback(async () => {

        const data = await getDocs(query(collection(db, 'players')))

        let players = {
            list: [],
            players: {}
        }
        data.forEach( d => {
            
            players.list.push(d.id)

            players.players[d.id] = {
                pid: d.id,
                ...d.data(),
                category: d.data()?.category?.toUpperCase().trim()
            }
        })

        //players.list.sort((a,b) => (players.players[a].name > players.players[b].name)?1:-1)
        players.list.sort((a, b) => players?.players[a]?.name?.localeCompare(players?.players[b]?.name));

        
        let num_cat = {}
        players?.list.map(p => {
            if(num_cat[players.players[p].category])
                num_cat[players.players[p].category]++;
            else
                num_cat[players.players[p].category] = 1;
                
            players.players[p]['num'] = `${players.players[p].category}${num_cat[players.players[p].category]}`
        })
        
        setPlayers({...players})
    }, [])
    
    const getTeams = useCallback(async () => {
        const data = await getDocs(query(collection(db, 'teams')))
        let teams = {
            list: [],
            teams: {}
        }
        console.log(catogories)
        data.forEach(d => {
            teams.list.push(d.id)
            teams.teams[d.id] = {
                tid: d.id,
                ...d.data(),
                players:[],
                points: 700000,
                reservedPoints: 350000,
                extraPoints: 350000,
                counts:catogories.reduce((acc, c) => ({ ...acc, [c]: 0 }), {}) 
            }
        })

        teams.list.sort((a,b) => (teams.teams[a].name > teams.teams[b].name)?1:-1)  
        console.log(teams)
        setTeams({...teams})
    }, [catogories])

    useEffect(() => {
        const func = async () => {
            await getCatData()
        }
        func()
    }, [getCatData])

    useEffect(() => {
        if(catData === null || catogories === null)
            return;
        
        console.log(catogories)
        const func = async () => {
            await getTeams();
            await getPlayers();
        }
        func()
    }, [catData, catogories, getTeams, getPlayers])

    useEffect(() => {
        if(players === null || teams === null)
            return;
        const func = async () => {
            await getReserved();
        }
        func()
    }, [players, teams, getReserved])

    useEffect(() => {

        if(players!==null && teams!==null && catData!==null && reservedPlayers!==null)
        {   
            if(initailLoading)
            {
                console.log('here') 
                setInitialLoading(false)
            }
        }

    }, [catData, players, teams, reservedPlayers])
    

    useEffect(() => {

        if(teams === null || players === null || catData === null)
            return;

        const soldPlayersQuery = query(
            collection(db, 'soldplayers'), 
            orderBy('timestamp')
        );

        const unsunscribe = onSnapshot(soldPlayersQuery, snapshot => {
            
            const newSoldPlayers = snapshot.docs.map(doc => ({
                aid: doc.id,
                ...doc.data(),
                cost: parseInt(doc.data().cost)
            }))

            console.log("newSoldPlayers: ",newSoldPlayers)

            if(JSON.stringify(oldSoldPlayers) === JSON.stringify(newSoldPlayers))
                return

            setLatestSell(newSoldPlayers.slice(-1)[0])
            setSoldPlayers(newSoldPlayers)

            const addedPlayers = newSoldPlayers.filter(
                newPlayer => 
                    !oldSoldPlayers.some(oldPlayer => oldPlayer.aid === newPlayer.aid)
            );

            const removedPlayers = oldSoldPlayers.filter(
                oldPlayer => 
                    !newSoldPlayers.some(newPlayer => oldPlayer.aid === newPlayer.aid)
            );

            if(addedPlayers.length > 0) {
                setTeams((prevTeams) => {
                    const updatedTeams = { ...prevTeams };
                    console.log(updatedTeams)
                    addedPlayers.forEach((player) => {
                      const team = updatedTeams.teams[player.tid];
                      const category = players.players[player.pid].category
                      const basePrice = parseInt(catData[category].basePrice);
                      if (!team?.players.includes(player.pid)) {
                        team.players.push(player.pid);
                        team.points -= player.cost;
                        team.reservedPoints -= basePrice
                        team.extraPoints -= (player.cost - basePrice);
                        team.counts[category]++;
                      }
                    });
                    return updatedTeams;
                });
            }

            if(removedPlayers.length > 0) {
                setTeams((prevTeams) => {
                    const updatedTeams = { ...prevTeams };
                    removedPlayers.forEach((player) => {
                        const team = updatedTeams.teams[player.tid];
                        const category = players.players[player.pid].category
                        const basePrice = parseInt(catData[category].basePrice);
                        team.players = team.players.filter((p) => p !== player.pid);
                        team.points += player.cost;
                        team.reservedPoints += basePrice
                        team.extraPoints += (player.cost - basePrice)
                        team.counts[category]--;
                    });
                    return updatedTeams;
                });
            }

            setOldSoldPlayers(newSoldPlayers)
        });

        return () => unsunscribe();

    }, [teams, players, catData])

    useEffect(() => {
        if(reservedPlayers && reservedPlayers.length > 0)
        {
            reservedPlayers.map(r => {
                console.log("reserved Player: ", r)
                const category = players?.players[r.pid]?.category
                const basePrice = parseInt(catData[category]?.basePrice)
                if(teams?.teams[r.tid]?.players?.filter(p => p === r.pid).length === 0)
                {
                    teams?.teams[r.tid]?.players.push(r.pid)
                    teams.teams[r.tid].points -= r.cost
                    teams.teams[r.tid].reservedPoints -= basePrice
                    teams.teams[r.tid].extraPoints -= (r.cost - basePrice)
                    teams.teams[r.tid].counts[category]++;
                }
            })
        }
    }, [reservedPlayers])

    const memo = useMemo(() => ({
        players,
        setPlayers,
        catogories,
        teams,
        latestSell,
        soldPlayers,
        catData,
        reservedPlayers,
        rawCatData,
        setReservedPlayers,
    }), [players, catogories, teams, latestSell, soldPlayers, reservedPlayers, rawCatData, catData])
    
    return <AppContext.Provider value={memo}>
        {initailLoading?<Center height="100vh" width="100vw">
      <TailSpin
        visible={true}
        height="80"
        width="80"
        color="#ffffff"
        ariaLabel="tail-spin-loading"
        radius="1"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </Center>:children}
    </AppContext.Provider>
}

export default function useApp() {
    return useContext(AppContext);
}
